export interface ResolutionRatePoint {
	date: string
	rate: number
	total: number
	aiResolved: number
	isPartial?: boolean
}

export const RESOLUTION_RATE_LOOKBACK_WEEKS = [4, 12] as const

// The running week has had less time to resolve, so the latest full week is the
// headline and each change compares it to the full week that many weeks before.
export const resolutionRateTrend = (points: readonly ResolutionRatePoint[]) => {
	const full = points.filter((point) => !point.isPartial)
	const latest = full.at(-1)
	if (!latest) return null

	return {
		latest,
		changes: RESOLUTION_RATE_LOOKBACK_WEEKS.flatMap((weeks) => {
			const past = full.at(-1 - weeks)
			if (!past) return []
			return [
				{ weeks, points: Math.round((latest.rate - past.rate) * 10) / 10 },
			]
		}),
	}
}
